import { format } from "colbi_web_ui/lib/utils";

export function convertBytesToMegaBytes(value, precison = 2) {
    if (value) {
        return (value / Math.pow(1024, 2)).toFixed(precison).toString();
    }
    return "N/A";
}

export function formatFileSize(value, precision = 2) {
    if (value === null || value === undefined || value === '') {
        return "N/A";
    }
    
    const bytes = parseFloat(value);
    if (isNaN(bytes)) {
        return "N/A";
    }
    
    // Handle zero or negative values
    if (bytes <= 0) {
        return "0 B";
    }
    
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const threshold = 1024;
    
    let unitIndex = 0;
    let size = bytes;
    
    // Find the appropriate unit
    while (size >= threshold && unitIndex < units.length - 1) {
        size /= threshold;
        unitIndex++;
    }
    
    // For bytes, don't show decimal places
    if (unitIndex === 0) {
        return `${Math.floor(size)} ${units[unitIndex]}`;
    }
    
    // For other units, use specified precision
    return `${size.toFixed(precision)} ${units[unitIndex]}`;
}

export function adjustForTimezone(date) {
    const adjustedDateTimeZone = new Date(date);
    const timeOffsetInMS = adjustedDateTimeZone.getTimezoneOffset() * 60000;
    return new Date(adjustedDateTimeZone.setTime(adjustedDateTimeZone.getTime() + timeOffsetInMS));
}

export function checkNumberValues(value) {
    if (value && value !== "N/A") {
        return format(value);
    }
    return "N/A";
}

export const formatCurrencyValues = (currencyOptions, value) => {
    const { locale, currency } = JSON.parse(currencyOptions || "{}");
    return locale && currency ? format(value, "normal", currency, 2, locale) : format(value, "normal", null, 2);
};

export function buildNavigationMenu(navigationMenu, i18n) {
    const navigationObj = (navigationMenu || []).reduce((acc, elem) => {
        const { name } = elem || {};
        if (!acc[name]) {
            acc[name] = {
                name: elem.name,
                to: elem.to,
                exact: true,
                icon: elem.icon,
            };
        }
        acc[name]["name"] = i18n`${elem.name}`;
        return Object.values(acc);
    }, []);
    return navigationObj;
}
